import { roleDisplayNames } from "./roleDisplayNames";
import type { UserRoleEnum } from "@globals";

/**
 * Get the display name for a user role
 * @param role - The role enum value
 * @returns The user-friendly display name
 */
export function getRoleDisplayName(role: UserRoleEnum): string {
  const roleDisplayName = roleDisplayNames.get(role);
  if (roleDisplayName === undefined) {
    throw Error("undefined role display name");
  }

  return roleDisplayName;
}
